import React from "react";
// import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import KucukcekmeceIntro from "../components/ServiceRegions/İntros/KucukcekmeceIntro";
import DynamicImage from "../components/DynamicImage";


const KüçükçekmecePage = () => {
  return (
    <> 
    <div>
        
      {/* <HeroSlider /> */}
      <DynamicImage />
      {/* <AboutSection/> */}
      <KucukcekmeceIntro/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};

export default KüçükçekmecePage;
